<template>
  <div
    v-if="isMobile"
    data-qa="mistake_btn"
    class="d-inline-flex text-body-2 link-decoration-underline primary--text cursor-pointer"
    @click="handleClickMistake"
  >
    {{ tStatic('Сообщить об ошибке') }}
  </div>
  <div
    v-else
    data-qa="mistake_btn"
    class="d-inline-flex text-body-2 link-decoration-underline primary--text cursor-pointer"
    :data-href="mistakeUrl"
    data-effect="mag-popup_anim_vertical"
    data-open-mistake-form
  >
    {{ tStatic('Сообщить об ошибке') }}
  </div>
</template>

<script lang="ts" setup>
import useIsMobile from 'src/composables/useIsMobile'
import useURLStore from 'src/store/useURLStore'
import useContextStore from 'src/store/useContextStore'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'

const props = defineProps<{
  lpuId: number
}>()

const { urlLang } = useContextStore()
const { reverseFullL10N } = useURLStore()
const mistakeUrl = reverseFullL10N({
  name: 'submit_mistake',
  args: {
    language: urlLang,
    obj_type: 'lpu',
    obj_id: String(props.lpuId),
  },
})
const isMobile = useIsMobile()

function handleClickMistake() {
  window.location.assign(mistakeUrl)
}
</script>
